export default __webpack_public_path__ + "static/media/pickax.b353acfc.png";